<template>
  <div class="rc-access-points">
    <ul class="rc-list-access-points" v-if="items.length">
      <li v-for="(item, index) in items" :key="index">
        <rc-btn
          block
          class="mx-auto"
          variant="lighter"
          @click="$emit('selected', item)"
        >
          <div>{{ item.name }}</div>
          <div class="rc-distance">{{ item.distance.toFixed(1) }} km</div>
          <span class="visually-hidden">{{ $t("a11y.button.more") }}</span>
        </rc-btn>
      </li>
    </ul>
    <ul class="rc-list-access-points" v-else>
      <li v-for="(item, index) in 6" :key="index">
        <rc-btn block class="mx-auto" variant="lighter">
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave"
            style="width: 75%"
          ></div>
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave"
            style="width: 25%"
          ></div>
        </rc-btn>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "RcSubscriberList",
  emits: ["selected"],

  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>
